import { CssBaseline, ThemeProvider } from "@mui/material";
import { StoreProvider } from "easy-peasy";
import "./App.css";
import AppRouter from "./router/app_router";
import store from "./store/store";
import theme from "./theme";
import "../src/styles/globals.scss";
import "../src/styles/variables.scss";
import Loader from "./components/loader/loader";
import { Helmet } from "react-helmet";
import { app_name, app_description, app_directory } from "./config/config";

function App() {
  return (
    <>
      <Helmet>
        <title>{app_name}</title>
        <meta name="description" content={app_description} />
        <link rel="icon" href={`/${app_directory}/favicon.ico`} />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`/${app_directory}/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href={`/${app_directory}/favicon-32x32.png`}
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href={`/${app_directory}/favicon-16x16.png`}
        />
        <link rel="manifest" href={`/${app_directory}/manifest.json`} />
      </Helmet>
      <StoreProvider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AppRouter />
          <Loader />
        </ThemeProvider>
      </StoreProvider>
    </>
  );
}

export default App;
